// extracted by mini-css-extract-plugin
export default {"color":"Proj4_color__VKvw3","middleTric":"Proj4_middleTric__E--2b","bgCard":"Proj4_bgCard__KFaZ5","linkPro":"Proj4_linkPro__7LLTv","imgSizeProj":"Proj4_imgSizeProj__2+uBp"};